import gql from "graphql-tag";

export const SET_REPORT_DATE_MUTATION = gql`
  mutation SetReportDate(
    $reportId: ID!
    $sheetId: ID
    $type: SetReportDateType!
    $timestamp: DateTime!
  ) {
    setReportDate(
      reportId: $reportId
      sheetId: $sheetId
      type: $type
      timestamp: $timestamp
    )
  }
`;
